import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Carousel from "./content/Carousel.js";
import {
  imageData1,
  imageData2,
  imageData3,
  imageData4,
  imageData5,
} from "../utils/ImageData";
import RightEquipment from "./content/RightEquipment";
import LeftEquipment from "./content/LeftEquipment";
import PopupForm from "../ui/PopupForm";
import { useTranslation } from "react-i18next";

const Content = () => {
  const { t } = useTranslation();
  const contentRef = useRef(null);
  const location = useLocation();

  const [isPopupOpen, setPopupOpen] = useState(false);
  const [popupType, setPopupType] = useState(null);

  useEffect(() => {
    const scrollToSection = () => {
      // if (location.hash) {
      //   const element = document.querySelector(location.hash);
      //   if (element) {
      //     element.scrollIntoView({ behavior: "smooth" });
      //   }
      // }
    };
    scrollToSection();
  }, [location]);

  const handlePopupOpen = (type) => {
    setPopupType(type);
    setPopupOpen(true);
  };

  const renderPopupContent = () => {
    switch (popupType) {
      case "drones":
        return (
          <section>
            <h2 className="text-2xl text-center font-bold mb-4">
              {t("content.droneTitle")}
            </h2>
            <div className="flex justify-center items-center mb-4">
              <Carousel className="w-[65%] h-[45%]" images={imageData1} />
            </div>
            <div className="px-5">
              <p className="mb-4">{t("content.droneDescription")}</p>
            </div>
          </section>
        );
      case "sensors":
        return (
          <section>
            <h2 className="text-2xl text-center font-bold mb-4">
              {t("content.sensorTitle")}
            </h2>
            <div className="flex justify-center items-center mb-4">
              <Carousel className="w-[60%] h-[40%]" images={imageData2} />
            </div>
            <div className="px-5">
              <p className="mb-4">{t("content.sensorDescription")}</p>
            </div>
          </section>
        );
      case "cameras":
        return (
          <section>
            <h2 className="text-2xl text-center font-bold mb-4">
              {t("content.cameraTitle")}
            </h2>
            <div className="flex justify-center items-center mb-4">
              <Carousel className="w-[60%] h-[40%]" images={imageData3} />
            </div>
            <div className="px-5">
              <p className="mb-4">{t("content.cameraDescription")}</p>
            </div>
          </section>
        );
      case "vehicles":
        return (
          <section>
            <h2 className="text-2xl text-center font-bold mb-4">
              {t("content.vehicleTitle")}
            </h2>
            <div className="flex justify-center items-center mb-4">
              <Carousel className="w-[60%] h-[40%]" images={imageData4} />
            </div>
            <div className="px-5">
              <p className="mb-4">{t("content.vehicleDescription")}</p>
            </div>
          </section>
        );
      case "monitoring":
        return (
          <section>
            <h2 className="text-2xl text-center font-bold mb-4">
              {t("content.monitoringTitle")}
            </h2>
            <div className="flex justify-center items-center mb-4">
              <Carousel className="w-[60%] h-[40%]" images={imageData5} />
            </div>
            <div className="px-5">
              <p className="mb-4">{t("content.monitoring_intro")}</p>
              <p className="mb-4">{t("content.monitoring_overview")}</p>

              <p className="text-lg font-bold mb-2">
                {t("content.monitoring_key_objectives")}
              </p>

              <p className="text-lg font-bold">
                {t("content.monitoring_integrated_system")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_integrated_point_1")}</li>
                <li>{t("content.monitoring_integrated_point_2")}</li>
                <li>{t("content.monitoring_integrated_point_3")}</li>
              </ul>

              <p className="text-lg font-bold">
                {t("content.monitoring_technological_advancements")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_tech_point_1")}</li>
                <li>{t("content.monitoring_tech_point_2")}</li>
                <li>{t("content.monitoring_tech_point_3")}</li>
              </ul>

              <p className="text-lg font-bold">
                {t("content.monitoring_innovative_solutions")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_innovative_point_1")}</li>
                <li>{t("content.monitoring_innovative_point_2")}</li>
                <li>{t("content.monitoring_innovative_point_3")}</li>
              </ul>

              <p className="text-lg font-bold">
                {t("content.monitoring_enhanced_surveillance")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_surveillance_point_1")}</li>
              </ul>

              <p className="text-lg font-bold">
                {t("content.monitoring_user_interface")}
              </p>

              <p className="text-lg font-bold">
                {t("content.monitoring_water_dashboard")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_water_point_1")}</li>
                <li>{t("content.monitoring_water_point_2")}</li>
                <li>{t("content.monitoring_water_point_3")}</li>
              </ul>

              <p className="text-lg font-bold">
                {t("content.monitoring_waste_dashboard")}
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>{t("content.monitoring_waste_point_1")}</li>
                <li>{t("content.monitoring_waste_point_2")}</li>
                <li>{t("content.monitoring_waste_point_3")}</li>
                <li>{t("content.monitoring_waste_point_4")}</li>
              </ul>
            </div>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <section
      id="solutions"
      ref={contentRef}
      className="bg-gray-100 xxs:px-auto xs:px-6 md:px-12 lg:px-16 xl:px-24"
    >
      {/* Main Title */}
      <div className="text-center lg:mb-28 md:mb-24 sm:mb-16 mb-16 lg:mt-28 xl:mb-40 md:mt-24 sm:mt-16 mt-16">
        <h2 className=" text-center mx-auto text-5xl xl:text-5xl xxs:text-4xl font-bold text-green-800">
          {t("content.contentTitle")}
        </h2>
      </div>

      {/* Equipment Sections */}
      <div className="space-y-4 xl:space-y-4 md:space-y-8 lg:space-y-8 xxs:px-2">
        <RightEquipment
          images={imageData1}
          equipmentBlock1="equipmentBlock1.titleDronesEquipmentBlock1"
          equipmentBlock2="equipmentBlock2.titleDronesEquipmentBlock2"
          equipmentText="equipmentText.textDronesEquipment"
          button="button.learnMore"
          className="xl:mb-48"
          onLearnMore={() => handlePopupOpen("drones")}
        />
      </div>
      <div className="space-y-4 xl:space-y-4 md:space-y-8 lg:space-y-8 xxs:px-2">
        <LeftEquipment
          images={imageData2}
          equipmentBlock1="equipmentBlock1.titleWaterSensorsEquipmentBlock1"
          equipmentBlock2="equipmentBlock2.titleWaterSensorsEquipmentBlock2"
          equipmentText="equipmentText.textWaterSensorsEquipment"
          button="button.learnMore"
          onLearnMore={() => handlePopupOpen("sensors")}
        />
      </div>
      <div className="space-y-4 xl:space-y-4 md:space-y-8 lg:space-y-8 xxs:px-2">
        <RightEquipment
          images={imageData3}
          equipmentBlock1="equipmentBlock1.titleCamerasEquipmentBlock1"
          equipmentBlock2="equipmentBlock2.titleCamerasEquipmentBlock2"
          equipmentText="equipmentText.textCamerasEquipment"
          button="button.learnMore"
          onLearnMore={() => handlePopupOpen("cameras")}
        />
      </div>
      <div className="space-y-4 xl:space-y-4 md:space-y-8 lg:space-y-8 xxs:px-2">
        <LeftEquipment
          images={imageData4}
          equipmentBlock1="equipmentBlock1.titleWasteCollectionVehicleBlock1"
          equipmentBlock2="equipmentBlock2.titleWasteCollectionVehicleBlock2"
          equipmentText="equipmentText.textWasteCollectionVehicle"
          button="button.learnMore"
          onLearnMore={() => handlePopupOpen("vehicles")}
        />
      </div>
      <div className="space-y-4 xl:space-y-4 md:space-y-8 lg:space-y-8 xxs:px-2 mb-28">
        <RightEquipment
          images={imageData5}
          equipmentBlock1="equipmentBlock1.titleApplicationBlock1"
          equipmentBlock2="equipmentBlock2.titleApplicationBlock2"
          equipmentText="equipmentText.textApplication"
          button="button.learnMore"
          onLearnMore={() => handlePopupOpen("monitoring")}
        />
      </div>

      {/* Popup Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setPopupOpen(false)}>
        {renderPopupContent()}
      </PopupForm>
    </section>
  );
};

export default Content;
